import { render, staticRenderFns } from "./clientsStatistics.vue?vue&type=template&id=0f4ba336"
import script from "./clientsStatistics.vue?vue&type=script&lang=js"
export * from "./clientsStatistics.vue?vue&type=script&lang=js"
import style0 from "./clientsStatistics.vue?vue&type=style&index=0&id=0f4ba336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports